import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Modal } from 'antd'
import { PortalRichText } from '../../../models/PortalArtigoModel'

const PortalRichTextEditor = React.lazy(async () => {
  const editorModule = await import('./PortalRichTextEditor')
  return { default: editorModule.PortalRichTextEditor }
})

interface PortalRichTextEditModalProps {
  open: boolean
  title: string
  value?: PortalRichText
  onCancel: () => void
  onSave: (value?: PortalRichText) => void
}

export function PortalRichTextEditModal({
  open,
  title,
  value,
  onCancel,
  onSave,
}: PortalRichTextEditModalProps) {
  const [draftValue, setDraftValue] = useState<PortalRichText | undefined>(value)
  const [isDirty, setIsDirty] = useState(false)

  useEffect(() => {
    if (open) {
      setDraftValue(value)
      setIsDirty(false)
    }
  }, [open, value])

  return (
    <Modal
      open={open}
      title={title}
      width={920}
      okText="Salvar alterações"
      cancelText="Cancelar"
      onCancel={onCancel}
      onOk={() => onSave(isDirty ? draftValue : value)}
      destroyOnClose
    >
      <ModalContent>
        <ModalIntroduction>
          Edite diretamente no texto. Selecione palavras para aplicar negrito ou link.
        </ModalIntroduction>
        <React.Suspense fallback={<EditorLoading>Carregando editor…</EditorLoading>}>
          <PortalRichTextEditor
            value={value}
            onChange={(nextValue) => {
              setDraftValue(nextValue)
              setIsDirty(true)
            }}
          />
        </React.Suspense>
      </ModalContent>
    </Modal>
  )
}

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const ModalIntroduction = styled.div`
  color: #595959;
`

const EditorLoading = styled.div`
  min-height: 260px;
  padding: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  color: #8c8c8c;
`
